import { Helmet } from 'react-helmet-async'
import { genarateSeoData } from 'shared/seo/schemaType'

const SeoHelmet = () => {
  const seoData = genarateSeoData(window.location.pathname) || {}
  const { title, description, url, schema } = seoData

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />

      {/* canonical */}
      <link rel="canonical" href={url} />

      {/* Schema Markup (JSON-LD) */}
      {!!schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  )
}

export default SeoHelmet
